const expandableText = () => {
	const expandableTexts = document.querySelectorAll('.expandable-text');

	if (expandableTexts.length === 0) {
		return;
	}

	expandableTexts.forEach((expandableText) => {
		const button = expandableText.querySelector('button');

		button.addEventListener('click', (e) => {
			const ariaExpanded = expandableText.getAttribute('aria-expanded');
			expandableText.setAttribute(
				'aria-expanded',
				ariaExpanded === 'true' ? 'false' : 'true'
			);
		});
	});
};

export default expandableText;
